import {Viewer} from "./js/Viewer";

document.addEventListener("DOMContentLoaded", () => {
	const hash = location.hash ? location.hash : {};

	if (document.querySelector('.rotate-object')) {
		document.getElementById('show-model').addEventListener('click', () => {
			document.querySelector('.image-preview').classList.toggle('show-model');

			if (!document.querySelector('.image-preview .model canvas')) {
				let view = new Viewer(document.querySelector('.rotate-object'), {
					kiosk: Boolean(hash.kiosk),
					model: hash.model || '',
					preset: hash.preset || '',
					cameraPosition: hash.cameraPosition
						? hash.cameraPosition.split(',').map(Number)
						: null
				});

				view
					.load(document.querySelector('.rotate-object').getAttribute('data-path'))
					.catch((e) => console.log(e))
					.then((gltf) => {
						console.log(gltf)
					})
				;
			}
		})

		document.getElementById('show-static').addEventListener('click', () => {
			document.querySelector('.image-preview').classList.remove('show-model');
		})
	}
});